/*------------------------------------------------------------

Program: TermsConditions.jsx
Application: Detailed Note of SMS Terms & Conditions
Option: For SMS Terms & Conditions
Date: 2026-08-19

---------------------------------------------------------------*/

import React, { Component } from "react";

export class TermsConditions extends Component {
  render() {
    return (
      <>
        <div className="privacy_sec">
          <div className="logo_privacy">
            <img
              src={require("../../assets/images/GFBOT-Horizontal.png").default}
              alt=""
            ></img>
          </div>
          <h1>SMS Terms & Conditions — GF Management, Inc.</h1>
          <ol>
            <li><b>Program</b> : GF Management, Inc. sends SMS messages for account security — one-time passcodes (OTP) and two-factor authentication.</li>
            <li><b>Message frequency</b>: Messages are sent per your login/verification request (e.g., one message per verification attempt).</li>
            <li><b>Cost</b>: Message and data rates may apply.</li>
            <li><b>Opt-out</b>: Reply STOP to cancel at any time.</li>
            <li><b>Help</b>: Reply HELP or contact <a target='_blank' rel="noreferrer" href="mailto:support@gfmanagement.com">
              support@gfmanagement.com.
            </a></li>
            <li><b>Privacy</b>: No mobile information will be shared with third parties or affiliates for marketing or promotional purposes.</li>
            <li>Carriers are not liable for delayed or undelivered messages.</li>
          </ol>
        </div>
      </>
    );
  }
}

export default TermsConditions;
